//user
export const SET_USERNAME = 'SET_USERNAME'
export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_TREEDTA = 'SET_TREEDTA'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_STAFFTYPE = 'SET_STAFFTYPE'
export const SET_LIMIT = 'SET_LIMIT'


export const SET_TABDATA = 'SET_TABDATA'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js